<a href="/">
    <default-logo [skin]="getMenuSkin()"></default-logo>
</a>
